var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/third-party/pdf.tsx
import * as React from "react";
import { pdfjs, Page, Document } from "react-pdf";
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.js`;
var Pdf = (_a) => {
  var _b = _a, { file } = _b, rest = __objRest(_b, ["file"]);
  const [numPages, setNumPages] = React.useState(null);
  function onDocumentLoadSuccess({ numPages: numPages2 }) {
    setNumPages(numPages2);
  }
  return /* @__PURE__ */ React.createElement(Document, __spreadValues({
    file,
    onLoadSuccess: onDocumentLoadSuccess
  }, rest), Array.from(new Array(numPages), (_, index) => /* @__PURE__ */ React.createElement(Page, {
    key: `page_${index + 1}`,
    pageNumber: index + 1
  })));
};
export {
  Pdf
};
